export default __webpack_public_path__ + "static/media/filtersButtonBlack.9b08a7a4.svg";